import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { ReactSVG } from 'react-svg';
import headerLogo from '../../assets/image/logo.svg';

const TermsConditions = () => (
  <div className="terms-pages">
    <div className="terms-pages__green-line" />
    <div className="terms-pages__wrapper">
      <div className="logo-block">
        <ReactSVG src={headerLogo} className="logo" alt="main logo" />
        <FormattedMessage
          id="terms.termsAndConditions"
          values={{
            h1: (...chunks) => <h1 className="title">{chunks}</h1>,
            br: <br />,
          }}
        />
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.block1.paragraph1"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
          }}
        />
        <FormattedMessage
          id="terms.block1.paragraph2"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
          }}
        />
        <FormattedMessage
          id="terms.block1.paragraph3"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            link1: (chunks) => (
              <a href="https://dashboard.openforestprotocol.org" target="_blank" rel="noreferrer">{chunks}</a>),
            link2: (chunks) => (
              <a href="https://validation.openforestprotocol.org" target="_blank" rel="noreferrer">{chunks}</a>),
          }}
        />
        <FormattedMessage
          id="terms.block1.paragraph4"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
          }}
        />
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.title"
          values={{
            h2: (...chunks) => <h2 className="article">{chunks}</h2>,
          }}
        />
        <ol>
          <FormattedMessage
            id="terms.sections.caption1"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#DEFINITIONS">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption2"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#GENERAL">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption3"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#ACCOUNT">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption4"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#ILLEGAL">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption5"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#PERSONAL">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption6"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#NEAR">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption7"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#OWNERSHIP">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption8"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#MARKETING">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption9"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#USING">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption10"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#CLAIMS">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption11"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#CIRCUMSTANCES">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption12"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#SEPARABILITY">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption13"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#CHANGES">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption14"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#SYSTEM">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption15"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#INDEMNITY">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption16"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#LIMITATION">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption17"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#DISCLAIMER">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption18"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#TERM">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption19"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#LANGUAGE">{chunks}</a>,
            }}
          />
          <FormattedMessage
            id="terms.sections.caption20"
            values={{
              li: (...chunks) => <li className="list-number">{chunks}</li>,
              anchorTo: (chunks) => <a href="#APPLICABLE">{chunks}</a>,
            }}
          />
        </ol>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption1-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="DEFINITIONS">{chunks}</h2>,
          }}
        />
        <FormattedMessage
          id="terms.definitions.paragraph1"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.definitions.paragraph2"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.definitions.paragraph3"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.definitions.paragraph4"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.definitions.paragraph5"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
            link1: (chunks) => (
              <a href="https://dashboard.openforestprotocol.org" target="_blank" rel="noreferrer">{chunks}</a>),
            link2: (chunks) => (
              <a href="https://validation.openforestprotocol.org" target="_blank" rel="noreferrer">{chunks}</a>),
          }}
        />
        <FormattedMessage
          id="terms.definitions.paragraph6"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
            link: (chunks) => (<a href="https://near.org/platform" target="_blank" rel="noreferrer">{chunks}</a>),
          }}
        />
        <FormattedMessage
          id="terms.definitions.paragraph7"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.definitions.paragraph8"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.definitions.paragraph9"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.definitions.paragraph10"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.definitions.paragraph11"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.definitions.paragraph12"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.definitions.paragraph13"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
            link: (chunks) => (
              <a href="https://www.openforestprotocol.org/" target="_blank" rel="noreferrer">{chunks}</a>),
          }}
        />
        <FormattedMessage
          id="terms.definitions.paragraph14"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption2-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="GENERAL">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.generalProvisions.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.generalProvisions.paragraph2"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
              LinkTo1: (chunks) => (<Link to="/privacy-notice">{chunks}</Link>),
              LinkTo2: (chunks) => (<Link to="/privacy-notice">{chunks}</Link>),
            }}
          />
          <FormattedMessage
            id="terms.generalProvisions.paragraph3"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.generalProvisions.paragraph4"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.generalProvisions.paragraph5"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.generalProvisions.paragraph6"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.generalProvisions.paragraph7"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.generalProvisions.paragraph8"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
              link: (chunks) => (
                <a
                  href="https://www.treasury.gov/resource-center/sanctions/Programs/Pages/Programs.aspx"
                  target="_blank"
                  rel="noreferrer"
                >
                  {chunks}
                </a>
              ),
            }}
          />
          <FormattedMessage
            id="terms.generalProvisions.paragraph9"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
              link1: (chunks) => (
                <a
                  href="https://www.treasury.gov/resource-center/sanctions/SDN-List/Pages/default.aspx"
                  target="_blank"
                  rel="noreferrer"
                >
                  {chunks}
                </a>
              ),
              link2: (chunks) => (
                <a
                  href="https://www.bis.doc.gov/index.php/the-denied-persons-list"
                  target="_blank"
                  rel="noreferrer"
                >
                  {chunks}
                </a>
              ),
              link3: (chunks) => (
                <a
                  href="https://eeas.europa.eu/headquarters/headquarters-homepage_en/8442/Consolidated%20list%20of%20sanctions"
                  target="_blank"
                  rel="noreferrer"
                >
                  {chunks}
                </a>
              ),
            }}
          />
          <FormattedMessage
            id="terms.generalProvisions.paragraph10"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption3-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="ACCOUNT">{chunks}</h2>,
          }}
        />
        <FormattedMessage
          id="terms.accountRegistration.paragraph1"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.accountRegistration.paragraph2"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.accountRegistration.paragraph3"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.accountRegistration.paragraph4"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.accountRegistration.paragraph5"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.accountRegistration.paragraph6"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.accountRegistration.paragraph7"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.accountRegistration.paragraph8"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.accountRegistration.paragraph9"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
        <FormattedMessage
          id="terms.accountRegistration.paragraph10"
          values={{
            p: (...chunks) => <p className="text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption4-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="ILLEGAL">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.illegalOrForbiddenActivity.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <ul className="text">
            <FormattedMessage
              id="terms.illegalOrForbiddenActivity.paragraph1.list1"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.illegalOrForbiddenActivity.paragraph1.list2"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.illegalOrForbiddenActivity.paragraph1.list3"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.illegalOrForbiddenActivity.paragraph1.list4"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.illegalOrForbiddenActivity.paragraph1.list5"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.illegalOrForbiddenActivity.paragraph1.list6"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.illegalOrForbiddenActivity.paragraph1.list7"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.illegalOrForbiddenActivity.paragraph1.list8"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.illegalOrForbiddenActivity.paragraph1.list9"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.illegalOrForbiddenActivity.paragraph1.list10"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
          </ul>
          <FormattedMessage
            id="terms.illegalOrForbiddenActivity.paragraph2"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.illegalOrForbiddenActivity.paragraph3"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.illegalOrForbiddenActivity.paragraph3.list1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.illegalOrForbiddenActivity.paragraph3.list2"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.illegalOrForbiddenActivity.paragraph3.list3"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.illegalOrForbiddenActivity.paragraph3.list4"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.illegalOrForbiddenActivity.paragraph3.list5"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.illegalOrForbiddenActivity.paragraph3.list6"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.illegalOrForbiddenActivity.paragraph4"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.illegalOrForbiddenActivity.paragraph5"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
              mailTo: (chunks) => <a href="mailto:o@openforestprotocol.org">{chunks}</a>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption5-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="PERSONAL">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.personalData.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.personalData.paragraph2"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.personalData.paragraph3"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.personalData.paragraph4"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
              mailTo: (chunks) => (<a href="mailto:o@openforestprotocol.org">{chunks}</a>),
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption6-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="NEAR">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.nearBlockchainAndThirdPartyServices.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.nearBlockchainAndThirdPartyServices.paragraph2"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.nearBlockchainAndThirdPartyServices.paragraph3"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.nearBlockchainAndThirdPartyServices.paragraph4"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.nearBlockchainAndThirdPartyServices.paragraph5"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.nearBlockchainAndThirdPartyServices.paragraph6"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption7-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="OWNERSHIP">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.ownershipLicenseAndCopyright.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <ul className="text">
            <FormattedMessage
              id="terms.ownershipLicenseAndCopyright.paragraph1.list1"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.ownershipLicenseAndCopyright.paragraph1.list2"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.ownershipLicenseAndCopyright.paragraph1.list3"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.ownershipLicenseAndCopyright.paragraph1.list4"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.ownershipLicenseAndCopyright.paragraph1.list5"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.ownershipLicenseAndCopyright.paragraph1.list6"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.ownershipLicenseAndCopyright.paragraph1.list7"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.ownershipLicenseAndCopyright.paragraph1.list8"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
            <FormattedMessage
              id="terms.ownershipLicenseAndCopyright.paragraph1.list9"
              values={{
                li: (...chunks) => <li className="list-style">{chunks}</li>,
              }}
            />
          </ul>
          <FormattedMessage
            id="terms.ownershipLicenseAndCopyright.paragraph2"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.ownershipLicenseAndCopyright.paragraph3"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.ownershipLicenseAndCopyright.paragraph4"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption8-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="MARKETING">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.marketingAndAnalytics.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.marketingAndAnalytics.paragraph2"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.marketingAndAnalytics.paragraph3"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption9-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="USING">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.usingCookieFiles.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
              link: (chunks) => (
                <a href="https://www.aboutcookies.org/" target="_blank" rel="noreferrer">{chunks}</a>),
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption10-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="CLAIMS">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.claimsAndNotifications.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption11-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="CIRCUMSTANCES">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.circumstanceOfInsuperableForce.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.circumstanceOfInsuperableForce.paragraph2"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption12-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="SEPARABILITY">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.separabilityOfTheAgreement.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption13-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="CHANGES">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.changesOnTheDashboard.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption14-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="SYSTEM">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.systemErrors.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.systemErrors.paragraph2"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption15-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="INDEMNITY">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.indemnityGuarantee.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.indemnityGuarantee.paragraph2"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              br: <br />,
            }}
          />
          <FormattedMessage
            id="terms.indemnityGuarantee.paragraph3"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption16-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="LIMITATION">{chunks}</h2>,
          }}
        />
        <ul>
          <li className="text">
            <FormattedMessage
              id="terms.limitationOfLiability.paragraph1"
              values={{
                bold: (chunks) => <b>{chunks}</b>,
              }}
            />
            <ul className="text">
              <FormattedMessage
                id="terms.limitationOfLiability.paragraph1.list1"
                values={{
                  li: (...chunks) => <li className="list-style">{chunks}</li>,
                }}
              />
              <FormattedMessage
                id="terms.limitationOfLiability.paragraph1.list2"
                values={{
                  li: (...chunks) => <li className="list-style">{chunks}</li>,
                }}
              />
              <FormattedMessage
                id="terms.limitationOfLiability.paragraph1.list3"
                values={{
                  li: (...chunks) => <li className="list-style">{chunks}</li>,
                }}
              />
              <FormattedMessage
                id="terms.limitationOfLiability.paragraph1.list4"
                values={{
                  li: (...chunks) => <li className="list-style">{chunks}</li>,
                }}
              />
              <FormattedMessage
                id="terms.limitationOfLiability.paragraph1.list5"
                values={{
                  li: (...chunks) => <li className="list-style">{chunks}</li>,
                }}
              />
              <FormattedMessage
                id="terms.limitationOfLiability.paragraph1.list6"
                values={{
                  li: (...chunks) => <li className="list-style">{chunks}</li>,
                }}
              />
              <FormattedMessage
                id="terms.limitationOfLiability.paragraph1.list7"
                values={{
                  li: (...chunks) => <li className="list-style">{chunks}</li>,
                }}
              />
            </ul>
          </li>
          <FormattedMessage
            id="terms.limitationOfLiability.paragraph2"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.limitationOfLiability.paragraph3"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption17-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="DISCLAIMER">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.disclaimer.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.disclaimer.paragraph1.list1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.disclaimer.paragraph1.list2"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.disclaimer.paragraph1.list3"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.disclaimer.paragraph1.list4"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption18-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="TERM">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.termAndTermination.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.termAndTermination.paragraph2"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.termAndTermination.paragraph3"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.termAndTermination.paragraph4"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.termAndTermination.paragraph5"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption19-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="LANGUAGE">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.languageAndTranslations.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="block_text">
        <FormattedMessage
          id="terms.sections.caption20-title"
          values={{
            h2: (...chunks) => <h2 className="article" id="APPLICABLE">{chunks}</h2>,
          }}
        />
        <ul>
          <FormattedMessage
            id="terms.applicableLaw.paragraph1"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
          <FormattedMessage
            id="terms.applicableLaw.paragraph2"
            values={{
              li: (...chunks) => <li className="text">{chunks}</li>,
              bold: (chunks) => <b>{chunks}</b>,
            }}
          />
        </ul>
      </div>
      <div className="copyright">
        © Open Forest Protocol,
        {' '}
        <FormattedDate value={Date.now()} year="numeric" />
      </div>
    </div>
  </div>
);

export default TermsConditions;
